import { FC } from 'react';
import FetchTable from 'components/table/FetchTable';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { Column } from 'react-table';
import { useTranslation } from 'react-i18next';
import { IMyLeave } from '../types';

const AnnualLeaves: FC = () => {
  const { client } = useActiveClientContext();
  const { t } = useTranslation();
  const date = new Date();
  const columns: Array<Column<IMyLeave>> = [
    {
      Header: 'ID',
      accessor: 'id',
    },
    {
      Header: t('leaves.month') || '',
      accessor: 'month',
      Cell: ({ value }) => {
        return <span>{t(`leaves.months.${value}`)}</span>;
      },
    },
    {
      Header: t('leaves.paid') || '',
      accessor: 'paid',
    },
    {
      Header: t('leaves.unpaid') || '',
      accessor: 'unpaid',
    },
    {
      Header: t('leaves.sick') || '',
      accessor: 'sick',
    },
  ];

  return (
    <>
      <h3 className="h5 mb-4 mt-5">{t('leaves.annualTitle')}</h3>
      <FetchTable<IMyLeave>
        entityName={buildClientEntity('my-annual-leaves', client)}
        entityEndpoint="leaves/year-schedule"
        columns={columns}
        hideFilterBar
        searchParams={{ year: date.getFullYear() }}
        pagination
      />
    </>
  );
};

export default AnnualLeaves;
